import { Text, Stack, Row, Col, ScreenClass } from '@leroy-merlin-br/backyard-react-ui'
import PropTypes from 'prop-types'

import { RatingStars } from 'reactShared/components/RatingStars'

import formatPriceToBRL from 'reactUtils/formatPriceToBRL'

import ButtonComponent from './Button'
import * as S from './styled'

const Product = ({
  onAddToCartClick,
  onProductNameClick,
  id,
  pictures,
  price: { to_price: price },
  name,
  url,
  unit
}) => {
  const Price = (screen) => (
    <Text size="mega" noMargin={screen !== 'untilKilo'} bold>
      {formatPriceToBRL(price)}
      <Text as="span" size="kilo" noMargin bold>/{unit}</Text>
    </Text>
  )

  return (
    <S.Wrapper>
      <S.Img src={pictures[0]} loading="lazy" height="82" width="82" />
      <S.Content>
        <Stack spacing="byte" align="center">
          <S.ProductTitle
            as="span"
            itemProp="name"
            onClick={onProductNameClick}
            size="kilo"
            align="left"
            noMargin
          >
            <a href={url} itemProp="name">{name}</a>
          </S.ProductTitle>
          <Row align="flex-end">
            <Col size={{ untilKilo: 4, kilo: 2, giga: 5, tera: 5 }}>
              <RatingStars id={id} url={url} />
              <ScreenClass render={Price} />
            </Col>

            <Col size={{ untilKilo: 4, kilo: 2, giga: 7, tera: 7 }}>
              <ButtonComponent
                onAddToCartClick={onAddToCartClick}
                id={id}
              />
            </Col>
          </Row>
        </Stack>
      </S.Content>
    </S.Wrapper>
  )
}

Product.propTypes = {
  onAddToCartClick: PropTypes.func.isRequired,
  onProductNameClick: PropTypes.func.isRequired,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  pictures: PropTypes.array.isRequired,
  price: PropTypes.object.isRequired,
  name: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  unit: PropTypes.string.isRequired
}

export default Product
